export const ELEMENT_CONFIG_TYPES = {
  INTERACTIVE: "INTERACTIVE_CONFIG",
  COMPONENT: "COMPONENT_CONFIG",
};

export const EVENT_NAMES = {
  UNDO_REDO: "UNDO_REDO",
  STAGE_UNDO_REDO: "stageUndoRedo",
  STAGE_UNDO: 'stageUndo',
  STAGE_REDO: 'stageRedo',
  MOVE_SECTION: 'moveSection',
  MOVE_STAGE_ELEMENTS: 'moveElements',
  PASTE_ELEMENTS: 'pasteElements',
  PASTE_COMPONENTS: 'pasteComponents',
  UPDATE_INLINE_ICON: 'updateInlineIcon',
  COMPONENTS_STAGE: 'componentsStage',
  COMPONENTS_SIDEBAR: 'componentsSidebar',
  COMPONENTS_SIDEBAR_INSTRUCTOR_GRADING: 'componentsSidebarInstructorGrading',
  ELEMENTS_SIDEBAR: 'elementsSidebar',
};

export const ACTIONS = {
  UNDO: "UNDO",
  REDO: "REDO",
  
};

export const DELETE_COMPONENT = 'deleteComponents';
export const RESTORE_COMPONENT = 'restoreComponents';
export const REVERT_CONFIG = 'revertConfig';
export const REVERT_COMPONENT_CONFIG = 'revertComponentConfig';
export const REVERT_MANUAL_GRADING_CONFIG = 'revertManualGradingConfig';

// Regex to match asset URNs (alfresco, external, or aero assets)
export const IMAGE_URN_REGEX = /urn:(alfresco|external|aero):[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/g;